import "./App.css";
import PrivateRoute from "./routes/PrivateRoute";
import { Route, Routes } from "react-router-dom";
import NotFound from "./components/NotFound/NotFound";
import SignIn from "./components/Auth/SignIn/SignIn";
import NewSignIn from "./components/Auth/AdminSignIn/SignIn";
import PublicRoute from "./routes/PublicRoute";
import Main from "./components/Layout/Main/Main";
import * as links from "./utils/links";
import DashboardMaquinas from "./components/Main/Dashboard/DashboardMáquinas";
import ClientesDashboard from "./components/Main/Cliente/ClientesDashboard/ClientesDashboard";
import PagamentosSearch from "./components/Main/SearchPagamentos/PagamentosSearch";
import DeletePagamento from "./components/Main/SearchPagamentos/DeletePagamento";
import EditPagamento from "./components/Main/SearchPagamentos/EditPagamento";
import EditCliente from "./components/Main/Cliente/EditCliente/EditCliente";
import DeleteMaquina from "./components/Main/SearchPagamentos/DeleteMaquina";
import ClienteMaquinas from "./components/Main/Cliente/ClienteMaquinas/ClienteMaquinas";
import HelpPage from "./components/Main/HelpPage/HelpPage";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import React, { useContext, useEffect } from "react";
import { AuthContext } from "./contexts/AuthContext";
import AddMachine from "./components/Main/AddMachine/AddMachine";
import AddCliente from "./components/Main/Cliente/AddCliente/AddCliente";
import RemoteCredit from "./components/Main/RemoteCredit/RemoteCredit";
import DeleteCliente from "./components/Main/Cliente/DeleteCliente/DeleteCliente";
import Relatorio from "./components/Main/Relatorio/Relatorio/Relatorio";
import TokenHelpPage from "./components/Main/TokenHelpPage/TokenHelpPage";
import AdminPagamentosSearch from "./components/Main/Cliente/AdminSearchPagamentos/AdminPagamentosSearch";
import AdminEditPagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminEditPagamento";
import AdminDeletePagamento from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeletePagamento";
import ConfigSignIn from "./components/Auth/Config/ConfigSignIn/ConfigSignIn";
import Trocar from "./components/Main/Cliente/Trocar/Trocar";
import AddMaquina from "./components/Main/Cliente/AddMaquina/AddMaquina";
import CreditoRemoto from "./components/Main/Cliente/CreditoRemoto/CreditoRemoto";
import RelatorioAdmin from "./components/Main/Cliente/RelatorioAdmin/RelatorioAdmin";
import AdminDeleteALLPagamentos from "./components/Main/Cliente/AdminSearchPagamentos/AdminDeleteALLPagamentos";
import RelatorioDispAdmin from "./components/Main/Cliente/RelatorioDispAdmin/RelatorioDispAdmin";
import RelatorioDisp from "./components/Main/Cliente/RelatorioDisp/RelatorioDisp";
import ListaMaquinas from "./components/Main/Cliente/ListaMaquinas/ListaMaquinas";
import ResetSenha from "./components/Main/Cliente/ResetSenha/ResetSenha";
import PagamentosCliente from "./components/Main/Cliente/PagamentosCliente/PagamentosCliente";
import MaqPagamentosAdm from "./components/Main/Cliente/MaqPagamentos/Adm/MaqPagamentosAdm";
import MaqPagamentosCliente from "./components/Main/Cliente/MaqPagamentos/Cliente/MaqPagamentosCliente";
import MensalidadesAdm from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdm";
import MensalidadesAdmList from "./components/Main/Cliente/Mensalidades/Adm/MensalidadesAdmList";
import MensalidadesCliente from "./components/Main/Cliente/Mensalidades/Cliente/MensalidadesCliente";

// Colaboradores
import Colaboradores from "./components/Main/Cliente/Colaboradores/Colaboradores";
import AddColaborador from "./components/Main/Cliente/Colaboradores/Cadastro/AddColaborador";
import EditColaborador from "./components/Main/Cliente/Colaboradores/Editacao/EditColaborador";
import ColaboradorSignIn from "./components/Auth/ColaboradorSign/ColaboradorSign";
import DashboardColaborador from "./components/Main/Cliente/Colaboradores/Dashboard/DashboardColaborador";
import PagamentosColaborador from "./components/Main/Cliente/Colaboradores/Pagamentos/PagamentosColaborador";
import ColaboradoresAdmin from "./components/Main/Cliente/ColaboradoresAdmin/ColaboradoresAdmin";
import AddColaboradorAdmin from "./components/Main/Cliente/ColaboradoresAdmin/Cadastro/AddColaboradorAdmin";
import PagamentosColaboradorAdmin from "./components/Main/Cliente/ColaboradoresAdmin/Pagamentos/PagamentosColaboradorAdmin";
import EditColaboradorAdmin from "./components/Main/Cliente/ColaboradoresAdmin/Editacao/EditColaboradorAdmin";

function App() {
  const {
    setDataUser,
    loading,
    notiMessage,
    setNotiMessage,
    notiMessageInfo,
    setNotiMessageInfo,
    authInfo,
  } = useContext<any>(AuthContext);

  const type = authInfo?.dataUser?.type;

  useEffect(() => {
    if (notiMessage) {
      setNotiMessage(null);

      switch (notiMessage.type) {
        case "error":
          NotificationManager.error(notiMessage.message, "Hmm... ");
          break;
        case "success":
          NotificationManager.success(notiMessage.message, "... ");
          break;
        case "info":
          NotificationManager.info(notiMessage.message, "... ");
          break;
        case "warning":
          NotificationManager.warning(notiMessage.message, "... ");
          break;
      }
    }
  }, [notiMessage]);

  // useEffect(() => {
  //     if (notiMessageInfo) {
  //         setNotiMessageInfo(null)
  //         NotificationManager.info(notiMessageInfo, '... ');
  //     }
  // }, [notiMessageInfo])

  return (
    <>
      <NotificationContainer />
      <Routes>
        {
          <>
            <Route
              path={`${links.FORNECEDOR_SEARCH_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <PagamentosSearch /> */}
                    <MaqPagamentosCliente/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_FORNECEDOR_SEARCH}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    {/* <AdminPagamentosSearch /> */}
                    <MaqPagamentosAdm/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdm/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_MENSALIDADES}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesCliente/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.MENSALIDADES_ADM_LIST}`}
              element={
                <PrivateRoute>
                  <Main>
                    <MensalidadesAdmList/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTE_PAGAMENTOS}`}
              element={
                <PrivateRoute>
                  <Main>
                    <PagamentosCliente/>
                    {/* <Dashboard/> */}
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CREDITO_REMOTO_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <CreditoRemoto />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDIT_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_EDIT_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminEditPagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_TROCAR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Trocar />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.ADD_CLIENTES_MAQUINA_ADM}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDITAR_CLIENTES}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR_CANAIS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS_DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeletePagamento />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINA_DELETE_PAGAMENTOS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AdminDeleteALLPagamentos />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_CLIENTE}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <Relatorio />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDispAdmin/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.RELATORIO_DISP}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <RelatorioDisp/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.CLIENTES_MAQUINAS}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <ClienteMaquinas />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.DELETE_FORNECEDOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <DeleteMaquina />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <HelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.TOKEN_HELP_PAGE}`}
              element={
                <PrivateRoute>
                  <Main>
                    <TokenHelpPage />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_FORNECEDOR}
              element={
                <PrivateRoute>
                  <Main>
                    <DashboardMaquinas></DashboardMaquinas>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <ClientesDashboard />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.LISTA_MAQUINAS}
              element={
                <PrivateRoute>
                  <Main>
                    <ListaMaquinas/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.NEW_PASSWORD}
              element={
                <PrivateRoute>
                  <Main>
                    <ResetSenha/>
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_MACHINE}
              element={
                <PrivateRoute>
                  <Main>
                    <AddMachine />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_CLIENTES}
              element={
                <PrivateRoute>
                  <Main>
                    <AddCliente />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.REMOTE_CREDIT}
              element={
                <PrivateRoute>
                  <Main>
                    <RemoteCredit />
                  </Main>
                </PrivateRoute>
              }
            />
            {/* Colaboradores */}
            <Route
              path={`${links.LISTA_COLABORADORES}`}
              element={
                <PrivateRoute>
                  <Main>
                    <Colaboradores />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.ADD_COLABORADOR}
              element={
                <PrivateRoute>
                  <Main>
                    <AddColaborador />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDIT_COLABORADOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditColaborador />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={links.DASHBOARD_COLABORADOR}
              element={
                <PrivateRoute>
                  <Main>
                    <DashboardColaborador />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.PAGAMENTOS_COLABORADOR}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <PagamentosColaborador />
                  </Main>
                </PrivateRoute>
              }
            />
            {/* Colaboradores Admin */}
            <Route
              path={`${links.LISTA_COLABORADORES_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <ColaboradoresAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.ADD_COLABORADOR_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <AddColaboradorAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.EDIT_COLABORADOR_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <EditColaboradorAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
            <Route
              path={`${links.PAGAMENTOS_COLABORADOR_ADMIN}/:id`}
              element={
                <PrivateRoute>
                  <Main>
                    <PagamentosColaboradorAdmin />
                  </Main>
                </PrivateRoute>
              }
            />
          </>
        }
        <Route
          path={links.SIGNIN}
          element={
            <PublicRoute>
              <SignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.ADMIN_SIGNIN}
          element={
            <PublicRoute>
              <NewSignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.COLABORADOR_SIGNIN}
          element={
            <PublicRoute>
              <ColaboradorSignIn />
            </PublicRoute>
          }
        />
        <Route
          path={links.CONFIG}
          element={
            <PublicRoute>
              <ConfigSignIn />
            </PublicRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
